var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79999 5.99999C1.79999 5.33725 2.33725 4.79999 2.99999 4.79999H21C21.6627 4.79999 22.2 5.33725 22.2 5.99999C22.2 6.66273 21.6627 7.19999 21 7.19999H2.99999C2.33725 7.19999 1.79999 6.66273 1.79999 5.99999ZM4.79999 12C4.79999 11.3372 5.33725 10.8 5.99999 10.8H18C18.6627 10.8 19.2 11.3372 19.2 12C19.2 12.6627 18.6627 13.2 18 13.2H5.99999C5.33725 13.2 4.79999 12.6627 4.79999 12ZM7.79999 18C7.79999 17.3372 8.33725 16.8 8.99999 16.8H15C15.6627 16.8 16.2 17.3372 16.2 18C16.2 18.6627 15.6627 19.2 15 19.2H8.99999C8.33725 19.2 7.79999 18.6627 7.79999 18Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter.859a951a2d5d608ac320920c0c22ad8a.svg";